import React, { useState, useEffect } from "react";
import axiosGeneral from "../../utils/axiosGeneral";
import { Skeleton } from "antd";

export default function ProfileVideosPage({ business }) {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        const response = await axiosGeneral().get(
          `/api/business/media/list/${business.id}/2`,
        );
        setVideos(response.data.data || []);
        console.log("ProfileVideosPage - Videos:", response.data);
        setError(null);
      } catch (err) {
        console.error("Error getting videos:", err);
        setError("Failed to load videos");
      } finally {
        setLoading(false);
      }
    };

    if (business && business.id) {
      fetchVideos();
    }
  }, [business.id]);

  if (loading) {
    return (
      <div id="videos" className="videos-container">
        <Skeleton active paragraph={{ rows: 4 }} />
      </div>
    );
  }

  if (error) {
    return (
      <div id="videos" className="videos-container">
        <p className="error-message">{error}</p>
      </div>
    );
  }

  return (
    <div id="videos" className="videos-container">
      {videos && videos.length > 0 ? (
        <div className="videos-grid">
          {videos.map((video, index) => (
            <div key={video.id || index} className="video-card">
              <div className="video-thumbnail">
                {video.thumbnail_url ? (
                  <img
                    src={video.thumbnail_url}
                    alt={video.name || `Video ${index + 1}`}
                    className="video-cover"
                  />
                ) : (
                  <div className="video-cover-placeholder">
                    <div className="placeholder-icon">🎬</div>
                  </div>
                )}
                <a
                  href={video.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="video-play-button"
                >
                  ▶
                </a>
              </div>
              <div className="video-info">
                <h3 className="video-title">
                  {video.name || `Video ${index + 1}`}
                </h3>
                <a
                  href={video.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="video-link"
                >
                  Watch video →
                </a>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-videos">
          <p>No videos available</p>
        </div>
      )}
    </div>
  );
}
